import {
  EVENT_DETAILS_STATUS_DRAFT,
  EVENT_DETAILS_STATUS_FAILED,
  EVENT_DETAILS_STATUS_PUBLISHED,
  EVENT_DETAILS_STATUS_SCHEDULED,
} from "../i18n/keysTranslations";
import { STATES } from "./constants";
import { getRetryablePlatformsFromScheduledContent } from "./organicPublishOutcome";

export const STATUS_CONFIG = {
  [STATES.DRAFT]: { labelKey: EVENT_DETAILS_STATUS_DRAFT, opacity: 0.5 },
  [STATES.SCHEDULED]: { labelKey: EVENT_DETAILS_STATUS_SCHEDULED, opacity: 1 },
  [STATES.PUBLISHED]: {
    labelKey: EVENT_DETAILS_STATUS_PUBLISHED,
    opacity: 0.8,
  },
  [STATES.FAILED]: { labelKey: EVENT_DETAILS_STATUS_FAILED, opacity: 1 },
};

export const resolveCalendarEventStatus = (statesByPlatform) => {
  const platformStates =
    statesByPlatform && typeof statesByPlatform === "object"
      ? Object.values(statesByPlatform).filter(Boolean)
      : [];

  if (platformStates.length === 0) return STATES.SCHEDULED;

  const visibleStates = platformStates.filter((s) => s !== STATES.SKIPPED);
  if (visibleStates.length === 0) return STATES.SKIPPED;

  const isFullyPublished = visibleStates.every((s) => s === STATES.PUBLISHED);
  if (isFullyPublished) return STATES.PUBLISHED;

  const anyFailed = visibleStates.some((s) => s === STATES.FAILED);
  if (anyFailed) return STATES.FAILED;

  const isFullyScheduled = visibleStates.every((s) => s === STATES.SCHEDULED);
  if (isFullyScheduled) return STATES.SCHEDULED;

  const isFullyDraft = visibleStates.every((s) => s === STATES.DRAFT);
  if (isFullyDraft) return STATES.DRAFT;

  return STATES.SCHEDULED;
};

export const classifyCalendarPublishIssue = (statesByPlatform) => {
  const values =
    statesByPlatform && typeof statesByPlatform === "object"
      ? Object.values(statesByPlatform).filter(Boolean)
      : [];

  if (values.length === 0) return null;

  const hasFailure = values.some((s) => s === STATES.FAILED);
  if (!hasFailure) return null;

  const publishedCount = values.filter((s) => s === STATES.PUBLISHED).length;
  if (publishedCount > 0) return "partial";

  return "failure";
};

export const hasAnyFailedPlatform = (statesByPlatform) =>
  statesByPlatform &&
  typeof statesByPlatform === "object" &&
  Object.values(statesByPlatform).some((state) => state === STATES.FAILED);

export const getCalendarEventDisplayStatus = (statesByPlatform) => {
  const state = resolveCalendarEventStatus(statesByPlatform);
  const publishIssue = classifyCalendarPublishIssue(statesByPlatform);

  return {
    state,
    publishIssue,
    isPartialFailure: publishIssue === "partial",
  };
};

export const isScheduledContentRetryable = ({
  platforms = [],
  states = {},
  platformsData = {},
}) =>
  getRetryablePlatformsFromScheduledContent({
    platforms,
    states,
    platformsData,
  }).length > 0;
